<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valOperator"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <!-- <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div> -->


        <div class="item">
          <span class="label">{{ $t('invoiceOrder.userid') }}</span>
          <el-input class="inp" size="small" v-model="formData.valUserId"
            :placeholder="$t('invoiceOrder.search.userId')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('invoiceOrder.email') }}</span>
          <el-input class="inp" size="small" v-model="formData.valEmail"
            :placeholder="$t('invoiceOrder.search.email')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('order.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valTel" :placeholder="$t('order.inp.name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('member.IdName') }}</span>
          <el-input class="inp" size="small" v-model="formData.valName"
            :placeholder="$t('invoiceOrder.search.name')"></el-input>
        </div>

      </div>
      <div class="btn-ct">
        <!-- <el-button @click="func.exportAllExcel(0)" class="search4" type="info">{{ $t('g.export') }}</el-button> -->
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" style="width: 100%" @row-click="func.showDetails">
        <el-table-column prop="Id" label="ID" width="60" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('g.agent_code')" width="80">
        </el-table-column>
        <el-table-column prop="UserId" width="100" :label="$t('invoiceOrder.userid')">
        </el-table-column>
        <el-table-column prop="NickName" width="100" :label="$t('bill.nickname')">
        </el-table-column>
        <el-table-column prop="Name" width="120" :label="$t('invoiceOrder.title')">
        </el-table-column>
        <el-table-column prop="Money" width="120" :label="$t('invoiceOrder.money')">
        </el-table-column>
        <el-table-column prop="TaxpayerNum" width="120" :label="$t('invoiceOrder.taxNo')">
        </el-table-column>
        <el-table-column prop="Email" width="120" :label="$t('invoiceOrder.email')">
        </el-table-column>
        <el-table-column prop="TypeStr" width="120" :label="$t('invoiceOrder.type')">
        </el-table-column>
        <el-table-column prop="StatusStr" width="120" :label="$t('member.status')">
        </el-table-column>
        <el-table-column prop="Address" width="120" :label="$t('invoiceOrder.address')">
        </el-table-column>
        <el-table-column prop="Bank" width="120" :label="$t('invoiceOrder.bankName')">
        </el-table-column>
        <el-table-column prop="BankAccount" width="120" :label="$t('invoiceOrder.bankAccount')">
        </el-table-column>
        <el-table-column prop="OrderTypeStr" width="120" :label="$t('invoiceOrder.type')">
        </el-table-column>
        <!-- <el-table-column prop="OrderIds" width="120" :label="$t('invoiceOrder.orderIds')">
        </el-table-column> -->

        <el-table-column prop="Remark" width="120" :label="$t('order.remark')" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="CodePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="CreatedAtStr" width="120" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column width="200" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.invalid(scope.row)" :class="scope.row.Status != -1 ? 'btn-add' : 'tag-info'"
              type="info" :disabled="scope.row.Status == -1">作废</el-button>
            <el-button v-if="scope.row.Status == 0" :class="scope.row.Status != 0 ? 'tag-info' : ' btn-add'"
              :disabled="scope.row.Status != 0" @click="func.showConfirmIssuance(scope.row)"
              type="primary">确认开具</el-button>
          </template>
        </el-table-column>


      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" align-center>
      <el-descriptions border column="2">
        <el-descriptions-item label="ID">{{ formData.curData.Id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')">{{ formData.curData.AgentCode }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.userid')">{{ formData.curData.UserId }}</el-descriptions-item>

        <el-descriptions-item :label="$t('bill.nickname')">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.NickName
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.title')">{{ formData.curData.Name }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.money')">{{ formData.curData.Money }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.taxNo')">{{ formData.curData.TaxpayerNum
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.email')">{{ formData.curData.Email }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.phone2')">{{ formData.curData.Phone }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.type')">{{ formData.curData.TypeStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.address')">{{ formData.curData.Address }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.phone')">{{ formData.curData.PhoneNum }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.bankName')">{{ formData.curData.Bank }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.bankAccount')">{{ formData.curData.BankAccount
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.type')">{{ formData.curData.OrderTypeStr
        }}</el-descriptions-item>

        <el-descriptions-item :label="$t('member.status')">{{ formData.curData.StatusStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.InvoiceSn')">{{ formData.curData.InvoiceSn
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')">{{ formData.curData.CodePath }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('workOrder.update_ID')">{{ formData.curData.UpdateUser || ''
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('workOrder.update_time')">{{ formData.curData.UpdatedAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.orderIds')">{{ formData.curData.OrderIds
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogVisibleIssuse" width="420" align-center>
      <div class="bound-info">
        <div class="item">
          <span class="form_tile">发票号码</span>
          <el-input style="width: 260px" v-model="formData.curData.invoiceNum" placeholder="请输入发票号码" />
        </div>
        <div class="item">
          <span class="form_tile"> {{ $t('order.remark') }}</span>
          <el-input style="width: 260px" v-model="formData.curData.Remark" placeholder="请输入备注" />
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="default" @click="formData.dialogVisibleIssuse = false">{{ $t('g.btn_cancel')
          }}</el-button>
          <el-button type="primary" @click="func.confirmIssuance()">{{ $t('g.btn_confirm') }}</el-button>
        </span>

      </template>
    </el-dialog>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserId"></MemberList>
    </el-drawer>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import { ElMessage, ElMessageBox } from 'element-plus'
import * as XLSX from 'xlsx/xlsx.mjs'
import MemberList from '@/views/member/list.vue'
export default {
  name: 'OrderBatteryReturn',
  components: {
    MemberList
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: 2
      },
      {
        label: t('member.statuses.success'),
        value: 1
      },
      {
        label: t('member.statuses.failed'),
        value: 0
      }
    ]
    const render = {
      shortcuts,
      statuses,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      valOperator: 0,
      valStatus: 2,
      valTime: '',
      valTel: '',
      valOrderSn: '',
      valDeviceId: '',
      dialogDisplayVisible: false,
      dialogVisibleIssuse: false,
      userDrawerVisible: false,
      // pagination
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1
    })
    const func = {
      async exportAllExcel(type = 1) {

        let params = {
        }
        if (formData.valOrderSn) {
          params.orderSn = formData.valOrderSn
        }
        if (formData.valDeviceId) {
          params.deviceId = formData.valDeviceId
        }
        if (formData.valOperator) {
          params.agentcode = formData.valOperator
        }
        if (formData.valTel) {
          params.nickname = formData.valTel
        }
        if (formData.valStatus != 2) {
          params.status = formData.valStatus
        }
        if (formData.valPhone) {
          params.phoneNum = formData.valPhone
        }
        if (formData.idName) {
          params.idName = formData.idName
        }
        if (formData.valTime) {
          params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
          params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
        }
        params.isExport = true
        params.IsStartWith = formData.IsStartWith
        let loading = ''
        if (params.exportType == 1) {
          loading = ElLoading.service({
            lock: true,
            text: t('openSlotsLit.loading'),
            background: 'rgba(0, 0, 0, 0.7)',
          })
        }
        let res = await axios.get(`/admin/order/return`, {
          params
        })
        let excleData = [[]];
        let wscols = [];
        excleData = [[
          'ID',
          t('openSlotsLit.agent_code'),
          t('openSlotsLit.site_name'),
          t('openSlotsLit.dev_id'),
          '用户Id',
          '姓名',
          '手机',
          '状态',
          '押金',
          '预计逾期扣费',
          '实际逾期扣费',
          '备注',
          '失败原因',
          t('g.create_at'),
        ]];
        wscols = [    // 每列不同宽度px
          { wch: 10 },
          { wch: 10 },
          { wch: 20 },
          { wch: 25 },
          { wch: 10 },
          { wch: 10 },
          { wch: 12 },
          { wch: 4 },
          { wch: 6 },
          { wch: 18 },
          { wch: 18 },
          { wch: 22 },
          { wch: 22 },
        ];
        const dictType = [
          t('openSlotsLit.types.all_slot'),
          t('openSlotsLit.types.all_empty_slot'),
          t('openSlotsLit.types.all_battery_slot'),
          t('openSlotsLit.types.Specify_slot'),
          t('openSlotsLit.types.full_charge_slot'),
        ]
        if (res && res.List) {
          for (let item of res.List) {
            let arr = [];
            item.StatusStr = item.DeviceStatus === 1 ? (item.Status == 2 ? t('order.returned') : t('member.statuses.success')) : t('member.statuses.failed')
            arr = [
              item.Id,
              item.AgentCode,
              item.DeviceSiteName,
              item.DeviceId,
              item.UserInfo?.Id,
              item.UserInfo?.IdName,
              item.UserInfo?.Mobile,
              item.StatusStr,
              item.ReturnOrderInfo?.Money,
              item.ReturnOrderInfo?.OverdueFee,
              item.ReturnOrderInfo?.RealOverdueFee,
              item.Remark,
              item.ReturnOrderInfo?.Result,
              toDay(item.CreatedAt),
            ]
            excleData.push(arr)
          }
        }

        const worksheet = XLSX.utils.aoa_to_sheet(excleData);
        worksheet["!cols"] = wscols;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, '还电订单' + '.xlsx');
      },
      showDetails(row) {
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      refresh() {
        formData.valOperator = 0
        formData.valStatus = 2
        formData.valTime = ''
        formData.valTel = ''
        func.loadData(1)
      },
      async invalid(row) {
        let params = {
          Id: row.Id,
          Status: -1,// 1开具 2作废
          Remark: ''
        }

        ElMessageBox.confirm('是否确认废除发票？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            let res = await axios.post('/admin/invoice/edit', params)
            ElMessage({
              type: 'success',
              message: res
            })

            func.loadData()
          } catch (e) {
            console.log(JSON.stringify(e), 242);

          }
        }).catch(() => { })

      },
      async showConfirmIssuance(row) {
        formData.dialogVisibleIssuse = true
        formData.curData = row
      },
      async confirmIssuance(row) {
        let params = {
          Id: formData.curData.Id,
          Status: 1,// 1开具 2作废
          Remark: formData.curData.Remark || '',
          InvoiceSn: formData.curData.invoiceNum || ''
        }
        try {
          let res = await axios.post('/admin/invoice/edit', params)
          ElMessage({
            type: 'success',
            message: res
          })
          formData.dialogVisibleIssuse = false
          func.loadData()
        } catch (e) {
          console.log(JSON.stringify(e), 242);

        }
        return;
        ElMessageBox.confirm('是否确认开具发票？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            let res = await axios.post('/admin/invoice/edit', params)
            ElMessage({
              type: 'success',
              message: res
            })
            formData.dialogVisibleIssuse = false
            func.loadData()
          } catch (e) {
            console.log(JSON.stringify(e), 242);

          }
        }).catch(() => { })
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.valOrderSn) {
            params.orderSn = formData.valOrderSn
          }
          if (formData.valDeviceId) {
            params.deviceId = formData.valDeviceId
          }
          if (formData.valOperator) {
            params.CodePath = formData.valOperator
          }
          if (formData.valTel) {
            params.Nickname = formData.valTel
          }
          if (formData.valUserId) {
            params.UserId = formData.valUserId
          }
          if (formData.valEmail) {
            params.Email = formData.valEmail
          }
          if (formData.valName) {
            params.Name = formData.valName
          }
          if (formData.valStatus != 2) {
            params.status = formData.valStatus
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.idName) {
            params.idName = formData.idName
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let res = await axios.get(`/admin/invoice/get`, {
            params
          })
          // console.log(JSON.stringify(res));

          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = item.CreatedAt ? toDay(item.CreatedAt) : ''
            item.UpdatedAtStr = item.UpdatedAt != 0 ? toDay(item.UpdatedAt) : ''
            if (item.Status == 0) {
              item.StatusStr = t('invoiceOrder.status.unissued')
            } else if (item.Status == 1) {
              item.StatusStr = t('invoiceOrder.status.issued')
            } else if (item.Status == -1) {
              item.StatusStr = t('invoiceOrder.status.cancelled')
            } else if (item.Status == 2) {
              item.StatusStr = t('invoiceOrder.status.cancelled')
            } else if (item.Status == 3) {
              item.StatusStr = t('invoiceOrder.status.rejected')
            }
            if (item.OrderType == 2) {
              item.OrderTypeStr = t('invoiceOrder.orderType.t2')
            } else if (item.OrderType == 19) {
              item.OrderTypeStr = t('invoiceOrder.orderType.t1')
            }
            item.TypeStr = item.Type == 0 ? t('invoiceOrder.types.individual') : t('invoiceOrder.types.company')

          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators()
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem 1.25rem 0 1.25rem;

  .bound-info {
    font-size: 14px;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-around;
    // align-items:;

    >.item {
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .inp-block {
    display: block;
  }

  .table-expand {
    padding-left: 4rem;
    padding-top: 1rem;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;
      margin-top: 12px;

      >.search1 {
        background-color: #14b2ec;
        color: #fff;
        border: 1px solid #14b2ec;
      }

      >.search2 {
        background-color: #048cbe;
        color: #fff;
        border: 1px solid #048cbe;
      }

      >.search3 {
        background-color: #ee8094;
        color: #fff;
        border: 1px solid #ee8094;
      }

      >.search4 {
        background-color: #bdb2b5;
        color: #fff;
        border: 1px solid #bdb2b5;
      }

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;
        // justify-content: left;

        .label {
          display: flex;
          justify-content: left;
          // margin-right: 0.325rem;
          // margin-left: 0.3rem;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  // >.data-table {
  //   :deep(.el-table) {
  //     .cell {
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //     }

  //     .el-table__row {
  //       cursor: pointer;
  //     }
  //   }
  // }

  .pagination {
    // text-align: right;
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;

    .title {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }
}

.line {
  height: 1px;
  width: 100%;
  background-color: #e2e2e2;
  margin-top: 15px;
  margin-bottom: 15px;
}

@media screen and (max-width:1300px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(3, 32.2%);
      }
    }
  }
}

@media screen and (max-width:1030px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(2, 48.8%);
      }
    }
  }
}

@media screen and (max-width:792px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(1, 100%);
      }
    }
  }
}
</style>
